export const colors = {
    greyBorder: '#d4d4d4',
    danger: '#9f3a38',
    black: '#000000',
    grey: 'grey',
    blue: 'rbg(38, 153, 219)',
    white: '#fff',
    lightGrey: '#f4f4f4',
};
